const oidc = {
    logout_success: 'Você saiu com sucesso.',
};
export default oidc;
